<template><section>

<h1>Icon 图标</h1>
<hr>
<p><code v-pre>hao-UI</code> 使用开源的阿里 Iconfont 作为图标库，并制作成了 <code v-pre>icon font</code>。</p>
<h3 id="shi-yong"><a class="header-anchor" href="#shi-yong" aria-hidden="true">¶</a> 使用</h3>
<p>使用 <code v-pre>class=&quot;h-icon-?&quot;</code> 来声明图标，具体图标的名称请 <code v-pre>copy</code> 相应的标签</p>
<div class="demo-block">
  <i class="h-icon-app"></i>
  <i class="h-icon-sql"></i>
  <i class="h-icon-text"></i>
  <i class="h-icon-addition"></i>
</div>
<demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;html&gt;&lt;head&gt;&lt;/head&gt;&lt;body&gt;&lt;i class=\&quot;h-icon-app\&quot;&gt;&lt;/i&gt;\n&lt;i class=\&quot;h-icon-sql\&quot;&gt;&lt;/i&gt;\n&lt;i class=\&quot;h-icon-text\&quot;&gt;&lt;/i&gt;\n&lt;i class=\&quot;h-icon-addition\&quot;&gt;&lt;/i&gt;\n\n&lt;/body&gt;&lt;/html&gt;&quot;,&quot;script&quot;:null,&quot;style&quot;:null}">
                            <div class="source" slot="source"><html><head></head><body><i class="h-icon-app"></i>
<i class="h-icon-sql"></i>
<i class="h-icon-text"></i>
<i class="h-icon-addition"></i>

</body></html></div>
                            
                            <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html">
<span class="hljs-tag">&lt;<span class="hljs-name">i</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"h-icon-app"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">i</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">i</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"h-icon-sql"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">i</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">i</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"h-icon-text"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">i</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">i</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"h-icon-addition"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">i</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3 id="tu-biao-ku"><a class="header-anchor" href="#tu-biao-ku" aria-hidden="true">¶</a> 图标库</h3>
<ul class="icon-list">
  <li v-for="name in icons" :key="name">
    <span>
      <i :class="'h-' + name"></i>
      {{'h-' + name}}
    </span>
  </li>
</ul>
</section></template>
<style lang="stylus" scoped>
  @import "../assets/styl/var.styl"
  .demo-block
    i
     font-size:20px
     margin-left:20px
    
  .demo-icon .source > i {
    font-size: 24px;
    color: #8492a6;
    margin: 0 20px;
    font-size: 1.5em;
    vertical-align: middle;
  }

  .icon-list {
    overflow: hidden;
    list-style: none;
    padding: 0;
    border-radius: 4px;
  }
  .icon-list li {
    float: left;
    width: 16.66%;
    text-align: center;
    height: 120px;
    line-height: 120px;
    color: #666;
    font-size: 13px;
    transition: color .15s linear;
    border: 1px solid $color-border;
    margin-right: -1px;
    margin-bottom: -1px;
    span {
      display: inline-block;
      line-height: normal;
      vertical-align: middle;
      font-family: 'Helvetica Neue',Helvetica,'PingFang SC','Hiragino Sans GB','Microsoft YaHei',SimSun,sans-serif;
      color: #99a9bf;
    }
    i {
      display: block;
      font-size: 32px;
      margin-bottom: 15px;
      color: #3f536e;
    }
    &:hover {
      color: rgb(92, 182, 255);
    }
  }
</style>
<script>
  var iconList = require('@/icon.json');
  export default {
    data() {
      return {
        icons: iconList
      };
    }
  }
</script>


// WEBPACK FOOTER //
// src/docs/icon.vue